export const GET_USERLISTACCORDINGROLE_LISTING =
  "GET_USERLISTACCORDINGROLE_LISTING"
export const GET_USERLISTACCORDINGROLE_LISTING_SUCCESS =
  "GET_USERLISTACCORDINGROLE_LISTING_SUCCESS"
export const GET_USERLISTACCORDINGROLE_LISTING_FAILED =
  "GET_USERLISTACCORDINGROLE_LISTING_FAILED"
